import axios from "axios"
import {NAME_SERVER} from "../Utils/NAME_HOST";


export const API_URL = NAME_SERVER + "/CasinoGamesApi";
//console.log(API_URL)
const $api = axios.create({
    withCredentials: true,// куки цепляются автоматический
    baseURL:API_URL
})
export default $api